import React from "react"
import {
  Header,
  Home,
  Companies,
  Services,
  Works,
  Quote,
  Journey,
  Stats,
  Awards,
  Footer,
  Journeypage,
  ScrollToTop,
  Projects,
  Studio,
  Akrutibuildcon,
} from "./components"

import { BrowserRouter, Route, Routes } from "react-router-dom"

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="overall-wrapper text-center bg-black">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <div className="bg-home-pageImage bg-cover bg-no-repeat bg-center block">
                  <Header />
                  <Home />
                </div>
                <div>
                  <Companies />
                  <Services />
                  <Works />
                  <Quote />
                  <Journey />
                  <Stats />
                  <Awards />
                </div>
              </>
            }
          />
          <Route path="/projects" element={<Projects />} />
          <Route path="/journeypage" element={<Journeypage />} />
          <Route path="/studio32" element={<Studio />} />
          <Route path="/akrutibuildcon" element={<Akrutibuildcon />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App
